export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/identity.js
// module id = 1vTr
// module chunks = 0